import Layout2 from "@/components/Layout/Layout2";
import LeftBar2 from "@/components/Layout/LeftBar2";
import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Separator } from "@radix-ui/react-separator";
import VatTab from "./tabs/vat";
import CookingTimeTab from "./tabs/cooking-time";
import HomePageTab from "./tabs/home-page";
import { backofficeLinks } from "@/components/lib/SidebarLinks";
import ServiceChargeTab from "./tabs/service-charge";
import hasPermission from "@/hooks/hasPermission";

function TakeOrderSettings(){
    const hasVat = hasPermission("back_office.settings.take_order_vat_settings");
    const hasCartView = hasPermission("back_office.settings.take_order_cart_view_settings");
    const hasCookingTime = hasPermission("back_office.settings.take_order_cooking_time");
    const hasServiceCharge = hasPermission("back_office.settings.take_order_service_charge");
    const hasHomePage = hasPermission("back_office.settings.take_order_home_page_settings");

    const defaultTab = hasVat
        ? "vat"
        : hasCartView
        ? "cart-view"
        : hasCookingTime
        ? "cooking-time"
        : hasServiceCharge
        ? "service-charge"
        : hasHomePage
        ? "home-page"
        : "";

    return(
        <Layout2
            LeftBar={<LeftBar2 sidebarLinks={backofficeLinks} />}
            pageName={{ title: "Overview" }}
            paths={[
            { name: "Back Office", path: "/backoffice/overview" },
            {
                name: "Settings",
                path: "",
            },
            {
                name: "Take Order Settings",
                path: "/backoffice/take-order-settings",
            },
            ]}
        >
            <div>
                <Tabs valueKey="vat" className="bg-transparent relative" defaultValue={defaultTab}>
                    <TabsList className="grid grid-cols-6 w-full">
                        <Separator className="absolute top-8 " />
                        {hasVat && <TabsTrigger className="bg-transparent" value="vat"> Vat  </TabsTrigger>}
                        {/* {hasCartView && <TabsTrigger className="bg-transparent" value="cart-view"> Cart View  </TabsTrigger>} */}
                        {hasCookingTime && <TabsTrigger className="bg-transparent" value="cooking-time"> Cooking Time  </TabsTrigger>}
                        {hasServiceCharge && <TabsTrigger className="bg-transparent" value="service-charge"> Service Charge  </TabsTrigger>}
                        {hasHomePage && <TabsTrigger className="bg-transparent" value="home-page"> Home Page  </TabsTrigger>}
                    </TabsList>
                    <Separator className=" absolute top-8 w-full h-[1px] bg-neutral-700" />
                    {hasVat && <VatTab />}
                    {hasCookingTime && <CookingTimeTab />}
                    {hasServiceCharge && <ServiceChargeTab />}
                    {hasHomePage && <HomePageTab />}
                </Tabs>
            </div>
        </Layout2>
    )
}

export default TakeOrderSettings;